































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class SchedulerList extends Vue {
  @Prop() public units!: any;

  @Prop() public unitID!: string;

  @Prop() public unitIcon!: string;

  @Prop() public unitLoading!: boolean;

  @Prop() public disableList!: boolean;

  public async onChangeUnit(item: any) {
    this.$emit('unitData', item.id);
    this.$emit('unitName', item.unitName);
  }
}
